interface HeroProps {
  onOpenConsultation: () => void;
}

const notifications = [
  { icon: "ri-phone-fill", color: "#22c55e", bg: "#dcfce7", text: "Nowe zapytanie — ogrodzenia", time: "teraz" },
  { icon: "ri-message-3-fill", color: "#3b82f6", bg: "#dbeafe", text: "Jan K.: Kiedy możecie wycenić?", time: "2 min" },
  { icon: "ri-user-add-fill", color: "#f59e0b", bg: "#fef3c7", text: "Nowy klient z Google", time: "5 min" },
  { icon: "ri-phone-fill", color: "#22c55e", bg: "#dcfce7", text: "Połączenie przychodzące", time: "12 min" },
];

const HeroSection = ({ onOpenConsultation }: HeroProps) => {
  const handleScrollToCalc = () => {
    const el = document.querySelector("#kalkulator");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-white">
      {/* Background gradient blobs */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full opacity-30"
          style={{ background: "radial-gradient(circle, #bfdbfe 0%, transparent 70%)", transform: "translate(200px,-150px)" }} />
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] rounded-full opacity-20"
          style={{ background: "radial-gradient(circle, #e0f2fe 0%, transparent 70%)", transform: "translate(-150px,150px)" }} />
        <div className="absolute top-1/2 left-1/3 w-[300px] h-[300px] rounded-full opacity-10"
          style={{ background: "radial-gradient(circle, #93c5fd 0%, transparent 70%)" }} />
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-6 lg:px-10 pt-28 pb-20 lg:pt-36 lg:pb-24">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">

          {/* Left content */}
          <div className="flex flex-col gap-7">
            <div className="flex items-center gap-3">
              <span className="inline-flex items-center gap-2 bg-[#EFF6FF] border border-[#BFDBFE] text-[#1D4ED8] text-xs font-semibold tracking-wide uppercase px-4 py-2 rounded-full">
                <span className="w-2 h-2 rounded-full bg-[#22c55e] animate-pulse inline-block"></span>
                Strony www dla lokalnych firm
              </span>
            </div>

            <div>
              <h2 className="text-4xl lg:text-5xl xl:text-[3.4rem] font-extrabold text-[#0F172A] leading-[1.12] tracking-tight">
                Strony dla firm usługowych, które{" "}
                <span className="relative inline-block">
                  <span className="relative z-10 text-[#1D4ED8]">generują telefony</span>
                  <span className="absolute bottom-1 left-0 w-full h-3 bg-[#BFDBFE]/60 -z-0 rounded-sm"></span>
                </span>{" "}
                i zapytania
              </h2>
            </div>

            <p className="text-lg lg:text-xl text-[#475569] leading-relaxed max-w-xl">
              Tworzę strony dla elektryków, hydraulików, firm budowlanych i usług lokalnych, które{" "}
              <strong className="text-[#0F172A]">realnie przynoszą klientów z Google</strong>.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 pt-1">
              <button
                onClick={handleScrollToCalc}
                className="whitespace-nowrap px-7 py-4 rounded-lg font-bold bg-[#1D4ED8] text-white hover:bg-[#1e40af] transition-all cursor-pointer text-base shadow-lg shadow-blue-500/20 hover:shadow-blue-500/30 hover:-translate-y-0.5 transform"
              >
                Sprawdź ile możesz mieć zapytań
              </button>
              <button
                onClick={onOpenConsultation}
                className="whitespace-nowrap px-7 py-4 rounded-lg font-semibold text-[#1D4ED8] border-2 border-[#BFDBFE] hover:border-[#1D4ED8] bg-white transition-all cursor-pointer text-base"
              >
                Umów bezpłatną konsultację
              </button>
            </div>

            <div className="flex flex-wrap gap-x-8 gap-y-3 pt-3 border-t border-gray-100">
              {[
                { icon: "ri-timer-line", text: "Realizacja 3–5 dni" },
                { icon: "ri-smartphone-line", text: "100% mobile" },
                { icon: "ri-map-pin-2-line", text: "Lokalne SEO" },
              ].map((item) => (
                <div key={item.text} className="flex items-center gap-2 text-sm text-[#64748B]">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={`${item.icon} text-[#1D4ED8]`}></i>
                  </div>
                  <span>{item.text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right — Phone visual with notifications */}
          <div className="hidden lg:flex justify-center items-center relative">
            {/* Growth chart background card */}
            <div className="absolute top-4 left-0 bg-white rounded-2xl border border-gray-100 p-5 w-52 shadow-sm">
              <p className="text-xs text-gray-400 mb-3 font-medium">Zapytania miesięcznie</p>
              <div className="flex items-end gap-1.5 h-16">
                {[3, 5, 4, 8, 7, 12, 11, 18, 17, 22].map((v, i) => (
                  <div
                    key={i}
                    className="flex-1 rounded-sm"
                    style={{
                      height: `${(v / 22) * 100}%`,
                      background: i >= 7 ? "#1D4ED8" : "#DBEAFE"
                    }}
                  />
                ))}
              </div>
              <div className="flex items-center justify-between mt-3">
                <span className="text-xl font-extrabold text-[#0F172A]">+220%</span>
                <span className="text-xs text-[#22c55e] font-semibold flex items-center gap-1">
                  <i className="ri-arrow-up-line"></i> wzrost
                </span>
              </div>
            </div>

            {/* Phone mockup */}
            <div className="relative w-64 mx-12">
              <div className="relative bg-[#0F172A] rounded-[2.5rem] p-2.5 shadow-2xl">
                <div className="absolute top-3 left-1/2 -translate-x-1/2 w-20 h-5 bg-[#0F172A] rounded-full z-10 flex items-center justify-center">
                  <div className="w-10 h-2 rounded-full bg-[#1a2234]"></div>
                </div>
                <div className="bg-white rounded-[2rem] overflow-hidden min-h-[480px] pt-6">
                  <div className="bg-gradient-to-b from-[#1D4ED8] to-[#1e3a8a] p-5 pb-8">
                    <p className="text-white/60 text-xs">Twoja strona</p>
                    <p className="text-white font-bold text-base mt-1">firma-elektryczna.pl</p>
                    <div className="mt-3 bg-white/10 rounded-xl p-3">
                      <p className="text-white text-xs font-semibold">Elektryk Kraków</p>
                      <p className="text-white/70 text-xs mt-0.5">#1 w Google</p>
                    </div>
                  </div>
                  <div className="p-4 flex flex-col gap-2.5 -mt-4">
                    {notifications.map((n, i) => (
                      <div
                        key={i}
                        className="bg-white border border-gray-100 rounded-xl p-3 flex items-center gap-3 shadow-sm"
                        style={{ animationDelay: `${i * 0.15}s` }}
                      >
                        <div
                          className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0"
                          style={{ backgroundColor: n.bg }}
                        >
                          <div className="w-4 h-4 flex items-center justify-center">
                            <i className={`${n.icon} text-sm`} style={{ color: n.color }}></i>
                          </div>
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="text-xs font-semibold text-[#0F172A] truncate">{n.text}</p>
                        </div>
                        <span className="text-[10px] text-gray-400 whitespace-nowrap">{n.time}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Glow under phone */}
              <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 w-40 h-8 bg-[#1D4ED8]/20 rounded-full blur-xl"></div>
            </div>

            {/* Lead badge right */}
            <div className="absolute bottom-10 right-0 bg-white rounded-2xl border border-gray-100 p-4 w-44 shadow-sm">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-7 h-7 rounded-full bg-[#dcfce7] flex items-center justify-center">
                  <div className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-user-smile-line text-sm text-[#22c55e]"></i>
                  </div>
                </div>
                <span className="text-xs font-semibold text-[#0F172A]">Nowy klient</span>
              </div>
              <p className="text-2xl font-extrabold text-[#0F172A]">22</p>
              <p className="text-xs text-gray-400">zapytań w tym miesiącu</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
